import axios from "axios";
import { objToFormData } from "../utilities/helperFunction.jsx";

export default function sendRequest(functionName, data) {
  let formData;
  if (data instanceof FormData) {
    formData = data;
  } else if (typeof data == "object") {
    formData = objToFormData(data);
  } else if (data == undefined) {
    formData = new FormData();
  } else {
    // formData = data;
  }

  return axios.post(
    `https://3940.ir/catalog-api/index.php${functionName}`,
    formData
  );
}
